// Meta Ads analytics — dev-only until the Meta launch. Like Walmart, no `feature` key (the Amazon
// marketplace capability gates do not apply to a Meta ad account). The group and every child
// carry `envOnly`, and the route itself is hard-blocked outside development by devOnlyPaths in
// src/router/index.js. The connect pages are a separate route (/integrations/meta, Settings).
const item = (title, to, icon) => ({
  title,
  action: 'read',
  subject: 'User',
  to,
  icon: { icon },
  envOnly: 'development',
});

export default [
  {
    title: 'Meta Ads',
    channel: 'meta',
    icon: { icon: 'logos:meta-icon' },
    envOnly: 'development',
    children: [item('Campaigns & Ads', 'meta-ads', 'ic:outline-campaign')],
  },
];
